import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";

const CustomFinanceStateSelect = ({ stateList, handleStateChange, value, apiLoading, name }) => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // Store filtered data
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const pageSize = 50;

    useEffect(() => {
        if (stateList?.length) {
            setData(stateList.slice(0, pageSize));
            setFilteredData(stateList);
        }
    }, [stateList]);

    const handleScroll = (event) => {
        const { target } = event;
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - 20) {
            loadMore();
        }
    };

    const loadMore = () => {
        if (loading || page * pageSize >= filteredData.length) return;

        setLoading(true);
        setTimeout(() => {
            setData((prev) => [
                ...prev,
                ...filteredData.slice(page * pageSize, (page + 1) * pageSize),
            ]);
            setPage((prev) => prev + 1);
            setLoading(false);
        }, 500);
    };

    const handleSearch = (value) => {
        if (!value) {
            setFilteredData(stateList);
            setData(stateList.slice(0, pageSize));
            setPage(1);
            return;
        }
        const filtered = stateList.filter((state) =>
            state?.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered);
        setData(filtered.slice(0, pageSize));
        setPage(1);
    };

    return (
        <Select
            name={name}
            disabled={apiLoading}
            className="finace-ant-select-form w-100"
            placeholder="Select City"
            showSearch
            onChange={(e) => handleStateChange(name, e)}
            value={value || undefined}
            onSearch={handleSearch}
            filterOption={false}
            onPopupScroll={handleScroll}
            options={data.map((state) => ({ label: state?.name, value: state?.name }))}
            dropdownRender={(menu) => (
                <>
                    {menu}
                    {loading && <Spin style={{ display: "block", textAlign: "center", padding: "10px" }} />}
                </>
            )}
        />
    );
};

export default CustomFinanceStateSelect;